export default "__VITE_ASSET__C6kMC9FO__"